module.exports = __webpack_public_path__ + "img/logo_collection.5a3cb6fc.svg";